import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';

export interface CrearEstudioRequest {
  nombre: string;
  indicaciones: string;
}

export interface ActualizarEstudioRequest {
  nombre: string;
  indicaciones: string;
}

@Injectable({
  providedIn: 'root',
})
export class EstudiosService {
  private apiUrl = `${environment.apiUrl}/estudios-solicitados`;

  constructor(private http: HttpClient) {}

  generarEstudio(atencionId: string, estudio: CrearEstudioRequest): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/${atencionId}`, estudio);
  }

  actualizarEstudio(estudioId: string, estudio: ActualizarEstudioRequest): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${estudioId}`, estudio);
  }

  eliminarEstudio(estudioId: string): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${estudioId}`);
  }
}
